module.exports = __webpack_public_path__ + "static/img/QR_android.ac4a66b0.png";